export const urls = {
  localization: `/localization/messages/v1/_search`,
  pgr_search: `/pgr-services/v2/request/_search`,
  tech_support_search_employee: `/dfs-tech-support/v1/requests/employee/_search`,
  tech_support_search_citizen: `/dfs-tech-support/v1/requests/_search`,
  tech_support_pgr_update: `/dfs-tech-support/v1/requests/_update`,
  pgr_update: `/pgr-services/v2/request/_update`,
  showcause_search: `/dfs-grm-showcause/showcause/v1/_search`,
  showcause_update: `/dfs-grm-showcause/showcause/v1/_update`,
  showcause_count: `/dfs-grm-showcause/showcause/v1/_count`,
  WorkFlowProcessSearch: `/egov-workflow-v2/egov-wf/process/_search`,
  resolvedWorkFlowProcessSearch: `/pgr-auto-escalate/workflow/process-instance/v1/_search`,
  WorkFlow: `/egov-workflow-v2/egov-wf/businessservice/_search`,
  MDMS: `/mdms-v2/v1/_search`,
  egov_mdms: `/egov-mdms-service/v1/_search`,
  dataUrl: `/dashboard-report/report/count`,
  assetsData: `/agent/v1/staticData/_search`,
  cropListData: `/soil-card/v1/fertilizer-crops`,
  fertilizerListData: `/soil-card/v1/fertilizer-codes`,
  weatherSearch: `/weather/weather_data/v1/_filter`,
  farmer_search: `/farmer-profile/v1/_search`,
  FileStore: "/filestore/v1/files",
  FileFetch: "/filestore/v1/files/id",
  UserProfileUpdate: "/user/profile/_update",
  ChangePassword: "/user/password/_update",
  resetPassword: "/user/password/nologin/_update",
  locationDetail: "/dfs-location/v1/_getChildBoundaries",
  location: {
    crops: `farmer-schemes/schemes/application/v1/_get-mapping?apiName=crop`,
    district: `/dfs-location/v1/_getChildBoundaries?boundaryType=District`,
    blocks: `/dfs-location/v1/_getChildBoundaries?boundaryType=Block`,
    panchayats: `/dfs-location/v1/_getChildBoundaries?boundaryType=Panchayat`,
    villages: `/dfs-location/v1/_getChildBoundaries?boundaryType=Village`,
  },
  SchemesDetailInfo: "/farmer-schemes/schemes/v1/_search",
  SchemeAgriInfo: "/farmer-schemes/schemes/application/v1/_get-mapping",
  DBTUserInfo: "/farmer/v1/dbt/_get",
  SchemeApply: "/farmer-schemes/schemes/application/v1/_apply",
  OTP_Send: "/user-otp/v1/_send",
  FARMER_DBT_DATA: "/farmer/v1/dbt/_get",
  support_OTP_Send: "/dfs-otp/v1/_send",
  complaint_pdf_download: "/pgr-auto-escalate/_pdfgenerate",
  create_support_grievance: "/dfs-tech-support/v1/requests/_create",
  agent_history_search: "/agent/audit/v1/_search",
  Agent_OTP_Send: "/agent/v1/otp/_send",
  Agent_Farmer_Search: "/agent/v1/entity/_search",
  Agent_Farmer_Scheme_Submit: "/agent/v1/proxy/_create",
  create_agent_farmer_grievance: `/agent/v1/proxy/_create`,
  Scheme_Recipt_Download: "/farmer-schemes/schemes/application/v1/_pdfgenerate",
  farmer_dbt_link_validation: `/farmer/v1/dbt/_linked`,
  agent_mandi_search: `/agent/v1/staticData/_search`,
  facility_search: `/facility/v1/_search`,
  facility_delete: `/facility/v1/bulk/_delete`,
  farmer_passbook_pdf: `/farmer-passbook/v1/_pdf`,
  farme_passbook_search: `/farmer-passbook/v1/_search`,
  dss: {
    dashboardConfig: "/dashboard-analytics/dashboard/getDashboardConfig",
    getCharts: "/dashboard-analytics/dashboard/getChartV2",
    dashboardReport: `/dashboard-report/report`,
  },
  farmer_profile: "/farmer-profile/v1/_search",
  farmer_applied_schemes: "/farmer-schemes/schemes/application/v1/_status",
  farmer_application_status: "/farmer-schemes/schemes/application/v1/_update",
};
